export interface ISpecialtyType {
    name: string;
    specialtyTypeId: string | number;
    netSuiteSpecialtyTypeId: string | number | null;
  }
  
  export const SpecialtyTypeFactory = {
    getDefault(): ISpecialtyType {
      return {
        name: '',
        specialtyTypeId: 0,
        netSuiteSpecialtyTypeId: ''
      };
    },
  };
  